import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { ClosedPeriodListFacade } from './closed-period-list.facade';

@Injectable({
  providedIn: 'root',
})
export class ClosedPeriodListGuard {
  constructor(private closedPeriodFacade: ClosedPeriodListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.closedPeriodFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.closedPeriodFacade);
  }
}
